// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-k_hg","advertDetailContactGroup__header":"c-k_hh","advertDetailContactGroup__value":"c-k_hi"};